// Compact 0–5 horizontal bar indicator used in the comparison table.
// Pure presentational, server-component friendly.

import { cn } from '@/lib/utils'

interface TraitBarProps {
  /** 0–5 score. Clamped on render. */
  value: number
  /** Hex color for the filled portion. Falls back to brand green. */
  color?: string
  /** When true, applies a stronger ring + brand color to mark the winner. */
  highlight?: boolean
  className?: string
}

export function TraitBar({ value, color, highlight = false, className }: TraitBarProps) {
  const clamped = Math.max(0, Math.min(5, value))
  const fillPct = (clamped / 5) * 100
  const fillColor = highlight ? '#16a34a' : color ?? '#16a34a'

  return (
    <div
      role="img"
      aria-label={`${clamped} out of 5`}
      className={cn(
        'relative h-2 w-24 overflow-hidden rounded-full bg-gray-100',
        highlight && 'ring-2 ring-green-100',
        className,
      )}
    >
      <span
        className="absolute inset-y-0 left-0 rounded-full transition-[width] duration-300"
        style={{ width: `${fillPct}%`, backgroundColor: fillColor }}
      />
    </div>
  )
}
